import { Checkbox } from "./ui/checkbox";
import { Compass } from "lucide-react";

export const SkillPicker = ({ strategies, value, onChange, disabled = false, renderExtra }) => {
  const withBehaviors = strategies.filter((s) => s.behaviors.length);
  const toggle = (id) => onChange(value.includes(id) ? value.filter((x) => x !== id) : [...value, id]);
  return (
    <div data-testid="skill-picker">
      <div className="flex items-baseline justify-between mb-1">
        <h3 className="font-grotesk text-base font-bold">Vaardigheden</h3>
        <span className="font-mono text-xs text-zinc-500" data-testid="employee-skill-count">{value.length} gekozen</span>
      </div>
      <p className="text-xs text-zinc-500 mb-3">Kies uit de gedragingen van de strategieën in de repository.</p>
      {withBehaviors.length === 0 && <p className="text-sm text-zinc-400" data-testid="no-behaviors-hint">Er zijn nog geen strategieën met gedragingen.</p>}
      <div className="space-y-4">
        {withBehaviors.map((s) => (
          <div key={s.id}>
            <div className="text-xs font-semibold flex items-center gap-1 mb-1.5"><Compass className="h-3 w-3" /> {s.name}</div>
            <div className="space-y-1">
              {s.behaviors.map((b) => (
                <label key={b.id} className={`flex items-start gap-2 px-2 py-1.5 text-sm border bg-white ${value.includes(b.id) ? "border-zinc-900" : "border-zinc-200"} ${disabled ? "" : "cursor-pointer"}`} data-testid="skill-option">
                  <Checkbox checked={value.includes(b.id)} disabled={disabled} onCheckedChange={() => toggle(b.id)} className="mt-0.5 rounded-none" data-testid={`skill-checkbox-${b.id}`} />
                  <span className="flex-1">{b.text}</span>
                  {renderExtra && renderExtra(b, s)}
                </label>
              ))}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};
